<div
    class="position-relative h-100 d-flex align-items-center pointer w-100 px-3 py-1 header"
>
    <a
        [routerLink]="['faq', 'say-thank-you']"
        class="start-50 link link_thankyou"
        >Как сказать спасибо авторам гайда</a
    >
    <div class="h-100 d-flex flex-column justify-content-center">
        <p class="m-0">Created by moms in Vilnius</p>
        <p class="m-0">
            Idea & Implementation:
            <a href="https://t.me/welcomemomsbot" target="_blank" class="link"
                >RitaFo</a
            >
        </p>
        <p class="m-0">
            Technical support:
            <a href="https://t.me/strepko" target="_blank" class="link"
                >Vladimir Grigorishin</a
            >
        </p>
    </div>
</div>
